// import { useEffect, useRef } from "react";

// const LogoSlider = ({ logos }) => {
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const slider = sliderRef.current;
//     if (!slider) return;

//     let scrollAmount = 0;
//     let animationFrameId;

//     const scrollSpeed = 0.5;
//     const totalWidth = slider.scrollWidth / 2;

//     const scroll = () => {
//       scrollAmount += scrollSpeed;
//       if (scrollAmount >= totalWidth) scrollAmount = 0;
//       slider.scrollLeft = scrollAmount;
//       animationFrameId = requestAnimationFrame(scroll);
//     };

//     animationFrameId = requestAnimationFrame(scroll);

//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   const duplicatedLogos = [...logos, ...logos];

//   return (
//     <div className="overflow-hidden w-full relative">
//       <div
//         ref={sliderRef}
//         className="flex gap-10 items-center"
//         style={{ whiteSpace: "nowrap", overflowX: "hidden" }}
//       >
//         {duplicatedLogos.map((logo, index) => (
//           <div
//             key={index}
//             className="flex items-center justify-center flex-shrink-0"
//             style={{ minWidth: "120px" }}
//           >
//             <img
//               src={logo?.light || ""}
//               alt="partner logo"
//               className="block object-contain h-6 sm:h-12 w-auto"
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default LogoSlider;

import { useRef } from "react";
import TiltCard from "./TiltCard";

const TextSlider = ({
  text = "",
  speed = 30,
}) => {
  const marqueeRef = useRef(null);

  return (
    <div className="overflow-hidden w-full bg-gray-900 py-6">
      <div
        ref={marqueeRef}
        className="inline-block whitespace-nowrap"
        style={{
          animation: `marquee ${speed}s linear infinite`,
        }}
      >
        {/* On répète assez pour couvrir 2x l’écran minimum */}
        {Array(4).fill(null).map((_, i) => (
          <span
            key={i}
            className="inline-block px-20 text-black text-xl md:text-2xl font-semibold tracking-wider"
          >
            {text}
          </span>
        ))}
      </div>
      <div className="mt-14 flex flex-col md:flex-row justify-center gap-12">
        <TiltCard logo="/images/logo/airbnb.png" color="#fff" link="https://www.airbnb.fr/?c=.pi0.pk90572135_4063331735&gclsrc=aw.ds&&c=.pi0.pk90572135_4063331735&localized_ghost=true&gad_source=1&gad_campaignid=90572135&gbraid=0AAAAADz55LlJW0EE-dVJcLthsvsU7uWN9&gclid=Cj0KCQiA_8TJBhDNARIsAPX5qxRT3NJmcqs9sBTwo5j97HmRKPhxLwY7i_W2Q2830AjMGriWJ5vC8QQaAgWVEALw_wcB"/>
        <TiltCard logo="/images/logo/booking.png" color="#003580" link="https://www.booking.com/index.fr.html?aid=2311236;label=fr-fr-booking-desktop-DCpBIW3k2*WIo8XuzMdB9AS652796013276:pl:ta:p1:p2:ac:ap:neg:fi:tikwd-65526620:lp9197112:li:dec:dm;ws=&gad_source=1&gad_campaignid=19637862690&gbraid=0AAAAAD_Ls1K_LNtOb3njWYcE6yH02taPU&gclid=Cj0KCQiA_8TJBhDNARIsAPX5qxRMLwT8qq0FhA3h6RFQMJi4shW82T_yyAuc5oXYJC1RmuolC0ddZGoaApNzEALw_wcB&chal_t=1764858227848&force_referer=https%3A%2F%2Fwww.google.com%2F"/>
      </div>
    </div>
  );
};

export default TextSlider;